import { AvailableRidesPageContent } from "@/components/availableRides/AvailableRidesPageContent";

const AvailableRides = () => {
  return <AvailableRidesPageContent />;
};

export default AvailableRides;
